import React, { useEffect, useState } from "react";
import { Award, ShieldCheck, Sparkles } from "lucide-react";
import api, { formatApiError } from "@/lib/api";

const AcademyCertificates = () => {
  const [rows,setRows] = useState([]);
  const [error,setError] = useState("");

  useEffect(() => {
    api.get("/api/academy/certificates/mine")
      .then(({data}) => setRows(Array.isArray(data) ? data : []))
      .catch(e => setError(formatApiError(e)));
  }, []);

  return (
    <div className="mx-auto max-w-[1300px] pb-12" data-testid="academy-certificates-page">
      <section className="relative mb-6 overflow-hidden rounded-[30px] border border-[#d4ab5e]/20 bg-[#0d0b08] p-6 md:p-8">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_10%_15%,rgba(212,171,94,.14),transparent_34%)]" />
        <div className="relative">
          <div className="flex items-center gap-2 font-mont text-[8px] uppercase tracking-[.3em] text-[#aa956e]"><Sparkles size={12}/> Dominio Académico</div>
          <h1 className="mt-2 font-cinzel text-3xl text-[#f1dcae] md:text-4xl">Certificados KD9</h1>
          <p className="mt-3 max-w-3xl font-cormorant text-xl text-[#b3a895]">Constancias verificables de los senderos académicos aprobados. No equivalen a licencia clínica ni diagnóstico.</p>
        </div>
      </section>

      {error && <div className="mb-5 rounded-2xl border border-red-400/20 bg-red-950/20 p-4 font-mont text-sm text-red-200">{error}</div>}

      <div className="grid gap-5 md:grid-cols-2">
        {rows.map(c => <article key={c.code} className="relative overflow-hidden rounded-[26px] border border-[#d4ab5e]/18 bg-[#100d09] p-7 text-center">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(212,171,94,.08),transparent_58%)]" />
          <div className="relative">
            <Award size={42} className="mx-auto mb-4 text-[#d4ab5e]"/>
            <div className="font-mont text-[8px] uppercase tracking-[.28em] text-[#8f836f]">Khaos Delta 9 certifica que</div>
            <h2 className="my-3 font-cinzel text-2xl text-[#efd7a6]">{c.student_name}</h2>
            <p className="font-cormorant text-lg text-[#b5aa97]">aprobó <strong>{c.course_title}</strong> con {c.score}%.</p>
            <div className="mt-5 inline-flex items-center gap-2 rounded-full border border-white/10 px-4 py-2 font-mont text-[8px] uppercase tracking-[.13em] text-[#ad9d82]"><ShieldCheck size={12}/> {c.code}</div>
            <p className="mt-4 font-mont text-[8px] leading-relaxed text-[#776f61]">{c.scope}</p>
          </div>
        </article>)}
      </div>

      {!rows.length && <div className="rounded-[26px] border border-white/8 bg-white/[.02] p-12 text-center font-cormorant text-xl text-[#a99d89]">Tus reconocimientos aparecerán cuando completes el sendero y apruebes su evaluación.</div>}
    </div>
  );
};
export default AcademyCertificates;
